import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import FormTypeForm from "./FormTypeForm";

export interface State {}

export interface CreateFormTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreateFormTypeForm extends React.Component<
  CreateFormTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;

    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newFormTypeData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormTypeData = values;
        }
      });
      return newFormTypeData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FormTypeForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
      />
    );
  }
}

export default CreateFormTypeForm;
